/** Semantic badge colors for project categories (account settings categories). */

import { DEFAULT_ACCOUNT_CATEGORIES, isPresetCategory, resolveCategoryChip } from './accountCategories';

/** @deprecated Use resolveAccountCategoryOptions from accountCategories.js */
export const PROJECT_BUILDER_CATEGORY_OPTIONS = [...DEFAULT_ACCOUNT_CATEGORIES];

export const PROJECT_CATEGORY_PALETTES = {
  business: { bgcolor: '#F8FAFC', color: '#475569', borderColor: '#E2E8F0' },
  creative: { bgcolor: 'rgba(249, 115, 22, 0.1)', color: '#c2410c', borderColor: 'rgba(249, 115, 22, 0.24)' },
  education: { bgcolor: '#F0FDF4', color: '#16A34A', borderColor: 'rgba(22, 163, 74, 0.22)' },
  marketing: { bgcolor: '#FFFBEB', color: '#D97706', borderColor: 'rgba(217, 119, 6, 0.22)' },
  technical: { bgcolor: '#EFF6FF', color: '#1D4ED8', borderColor: 'rgba(29, 78, 216, 0.22)' },
  writing: { bgcolor: '#F5F3FF', color: '#7C3AED', borderColor: 'rgba(124, 58, 237, 0.22)' },
  collections: { bgcolor: '#F0FDF4', color: '#16A34A', borderColor: 'rgba(22, 163, 74, 0.22)' },
  projects: { bgcolor: '#F0FDF4', color: '#16A34A', borderColor: 'rgba(22, 163, 74, 0.22)' },
  general: { bgcolor: '#F8FAFC', color: '#64748B', borderColor: '#E2E8F0' },
};

export function isProjectPresetCategory(category, options = PROJECT_BUILDER_CATEGORY_OPTIONS) {
  return isPresetCategory(category, options);
}

/** Map stored category to a builder chip; legacy values fall back to Other or Collections. */
export function resolveProjectCategoryChip(category, options = PROJECT_BUILDER_CATEGORY_OPTIONS) {
  const normalized = String(category || '').trim();
  if (normalized === 'Projects') return 'Collections';
  return resolveCategoryChip(category, options);
}

const BADGE_CHIP_BASE = {
  height: 24,
  fontSize: '0.75rem',
  fontWeight: 500,
  borderRadius: 999,
  '& .MuiChip-label': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    px: 1.25,
  },
};

export function normalizeProjectCategory(category) {
  return String(category || 'General').trim().toLowerCase();
}

export function getProjectCategoryPalette(category) {
  const key = normalizeProjectCategory(category);
  return PROJECT_CATEGORY_PALETTES[key] || PROJECT_CATEGORY_PALETTES.general;
}

export function getProjectCategoryBadgeSx(category) {
  const palette = getProjectCategoryPalette(category);
  return {
    ...BADGE_CHIP_BASE,
    maxWidth: { xs: '100%', sm: 160 },
    bgcolor: palette.bgcolor,
    color: palette.color,
    borderColor: palette.borderColor,
  };
}

export function getProjectContentSummaryChipSx() {
  return {
    height: 20,
    fontSize: '0.6875rem',
    fontWeight: 500,
    borderRadius: 999,
    maxWidth: { xs: '100%', sm: 200 },
    bgcolor: 'rgba(29, 78, 216, 0.08)',
    color: '#0f172a',
    borderColor: 'rgba(29, 78, 216, 0.18)',
    '& .MuiChip-label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      px: 0.875,
      py: 0,
      lineHeight: 1.25,
    },
  };
}

export function formatCapabilityCountLabel(count) {
  const n = Number(count) || 0;
  return `${n} ${n === 1 ? 'Capability' : 'Capabilities'}`;
}

export function formatKnowledgeCountLabel(count) {
  const n = Number(count) || 0;
  return `${n} ${n === 1 ? 'Knowledge Asset' : 'Knowledge Assets'}`;
}

/** Metadata line on project workspace header. */
export function formatKnowledgeItemCountLabel(count) {
  const n = Number(count) || 0;
  return `${n} ${n === 1 ? 'Knowledge Item' : 'Knowledge Items'}`;
}

export function formatProjectUpdatedLabel(dateValue) {
  if (!dateValue) return null;
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
